// Sube una firma manuscrita digitalizada (dataURL de la tableta o de un escaneo) como Binary + DocumentReference del paciente. Lo comparten
// el wizard del consentimiento (MotorFormularioConsentimiento.tsx) y la revocatoria del 024 (RevocatoriaConsentimiento024.tsx).
import type { MedplumClient } from '@medplum/core';
import type { DocumentReference, Patient, Reference } from '@medplum/fhirtypes';

export function dataUrlABytes(dataUrl: string, contentTypeFallback: string): { bytes: Uint8Array; contentType: string } {
  const match = /^data:([^;]*);base64,(.*)$/.exec(dataUrl);
  const contentType = match?.[1] || contentTypeFallback;
  const b64 = match ? match[2] : dataUrl;
  const binario = atob(b64);
  const bytes = new Uint8Array(binario.length);
  for (let i = 0; i < binario.length; i++) bytes[i] = binario.charCodeAt(i);
  return { bytes, contentType };
}

export async function subirFirmaComoDocumentReference(
  medplum: MedplumClient,
  subject: Reference<Patient>,
  dataUrl: string,
  contentType: string,
  filename: string,
  titulo: string,
): Promise<DocumentReference> {
  const { bytes, contentType: tipoReal } = dataUrlABytes(dataUrl, contentType);
  const binario = await medplum.createBinary({ data: bytes, contentType: tipoReal, filename, securityContext: subject }); // MT-042: el paciente, para la regla de vínculo asistencial
  return medplum.createResource<DocumentReference>({
    resourceType: 'DocumentReference',
    status: 'current',
    subject,
    type: { text: titulo },
    author: [subject],
    content: [{ attachment: { contentType: binario.contentType, url: `Binary/${binario.id}`, title: titulo } }],
  });
}
